var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGitlab = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2500,
  height: 2305,
  viewBox: "0 0 256 236",
  preserveAspectRatio: "xMinYMin meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m128.075 236.075 47.104-144.97H80.97l47.104 144.97z",
  fill: "#E24329"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M128.075 236.074 80.97 91.104H14.956l113.119 144.97z",
  fill: "#FC6D26"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.956 91.104.642 135.16a9.752 9.752 0 0 0 3.542 10.903l123.891 90.012-113.12-144.97z",
  fill: "#FCA326"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.956 91.105H80.97L52.601 3.79c-1.46-4.493-7.816-4.492-9.275 0l-28.37 87.315z",
  fill: "#E24329"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m128.075 236.074 47.104-144.97h66.015l-113.12 144.97z",
  fill: "#FC6D26"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m241.194 91.104 14.314 44.056a9.752 9.752 0 0 1-3.543 10.903l-123.89 90.012 113.119-144.97z",
  fill: "#FCA326"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M241.194 91.105h-66.015l28.37-87.315c1.46-4.493 7.816-4.492 9.275 0l28.37 87.315z",
  fill: "#E24329"
})));
export { SvgGitlab as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/gitlab.svg";